import { Prefecture } from "./prefecture.model";

export const prefectures: Prefecture[] = [
  { ID: 1, Name: 'Αττική' },
  { ID: 2, Name: 'Κεντρική Μακεδονία' },
  { ID: 3, Name: 'Κρήτη' },
  { ID: 4, Name: 'Ανατολική Μακεδονία και Θράκη' },
  { ID: 5, Name: 'Ήπειρος' },
  { ID: 6, Name: 'Ιόνια Νησιά' },
  { ID: 7, Name: 'Βόρειο Αιγαίο' },
  { ID: 8, Name: 'Πελοπόννησος' },
  { ID: 9, Name: 'Νότιο Αιγαίο' },
  { ID: 10, Name: 'Θεσσαλία' },
  { ID: 11, Name: 'Δυτική Ελλάδα' },
  { ID: 12, Name: 'Δυτική Μακεδονία' },
  { ID: 13, Name: 'Στερεά Ελλάδα' },
  { ID: 14, Name: 'Άγιο Όρος' },
  { ID: 15, Name: 'Αχαΐα' },
  { ID: 16, Name: 'Αιτωλοακαρνανία' },
  { ID: 17, Name: 'Αρκαδία' },
  { ID: 18, Name: 'Αργολίδα' },
  { ID: 19, Name: 'Άρτα' },
  { ID: 20, Name: 'Βοιωτία' },
  { ID: 21, Name: 'Χανιά' },
  { ID: 22, Name: 'Χίος' },
  { ID: 23, Name: 'Κέρκυρα' },
  { ID: 24, Name: 'Κορινθία' },
  { ID: 25, Name: 'Κυκλάδες' },
  { ID: 26, Name: 'Δωδεκάνησα' },
  { ID: 27, Name: 'Δράμα' },
  { ID: 28, Name: 'Εύβοια' },
  { ID: 29, Name: 'Έβρος' },
  { ID: 30, Name: 'Ευρυτανία' },
  { ID: 31, Name: 'Φλώρινα' },
  { ID: 32, Name: 'Φωκίδα' },
  { ID: 33, Name: 'Φθιώτιδα' },
  { ID: 34, Name: 'Γρεβενά' },
  { ID: 35, Name: 'Ηράκλειο' },
  { ID: 36, Name: 'Ημαθία' },
  { ID: 37, Name: 'Ιωάννινα' },
  { ID: 38, Name: 'Καρδίτσα' },
  { ID: 39, Name: 'Καστοριά' },
  { ID: 40, Name: 'Καβάλα' },
  { ID: 41, Name: 'Κεφαλονιά' },
  { ID: 42, Name: 'Κιλκίς' },
  { ID: 43, Name: 'Κοζάνη' },
  { ID: 44, Name: 'Λακωνία' },
  { ID: 45, Name: 'Λάρισα' },
  { ID: 46, Name: 'Λασίθι' },
  { ID: 47, Name: 'Λευκάδα' },
  { ID: 48, Name: 'Λέσβος' },
  { ID: 49, Name: 'Μαγνησία' },
  { ID: 50, Name: 'Μεσσηνία' },
  { ID: 51, Name: 'Ξάνθη' },
  { ID: 52, Name: 'Πέλλα' },
  { ID: 53, Name: 'Πιερία' },
  { ID: 54, Name: 'Πρέβεζα' },
  { ID: 55, Name: 'Ρέθυμνο' },
  { ID: 56, Name: 'Ροδόπη' },
  { ID: 57, Name: 'Σάμος' },
  { ID: 58, Name: 'Σέρρες' },
  { ID: 59, Name: 'Τρίκαλα' },
  { ID: 63, Name: 'Χαλκιδική' },
];
